import { render } from "./FileInfo.vue?vue&type=template&id=4e95b0ba"
import script from "./FileInfo.vue?vue&type=script&lang=js"
export * from "./FileInfo.vue?vue&type=script&lang=js"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__